import { Button, Input, Form, Drawer, ColorPicker, message, Switch } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";

import endpoints from "../../utils/endpoints.js";
import { DeleteOutlined, FileImageOutlined, FileOutlined } from "@ant-design/icons";
import Media from "../Media/media.js";
import config from "../../utils/config.js";

export default function Create({ data, open, close }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isOpenMedia, setIsOpenMedia] = useState(false);
  const [mediaKey, setMediaKey] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    if (open && data) {
      let aux = Object.assign({}, data);
      aux.answers = aux.answers ? JSON.parse(aux.answers) : [];
      form.setFieldsValue(aux);
    }
  }, [data]);

  function handleSubmit(values) {
    setIsButtonLoading(true);
    values.answers = values.answers ? JSON.stringify(values.answers) : JSON.stringify([]);
    axios
      .post(endpoints.game.update, {
        data: values,
      })
      .then((res) => {
        close();
        setIsButtonLoading(false);
        form.resetFields();
        message.success("Pergunta foi editada com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function handleWarningMissingFields() {
    message.error("Faltam alguns campos para preencher!");
  }

  function handleClose() {
    form.resetFields();
    close();
  }

  function openMedia(k) {
    setMediaKey(k);
    setIsOpenMedia(true);
  }

  function closeMedia(res) {
    if (res) {
      form.setFieldValue(mediaKey, res[mediaKey]);
    }

    setMediaKey(null);
    setIsOpenMedia(false);
  }

  return (
    <Drawer
      width={800}
      title={`Editar pergunta`}
      open={open}
      onClose={handleClose}
      maskClosable={false}
      extra={[
        <Button className="mr-2" size="large" type="primary" onClick={form.submit} loading={isButtonLoading} disabled={isButtonLoading}>
          Adicionar
        </Button>,
        <Button size="large" onClick={handleClose}>
          Cancelar
        </Button>,
      ]}
    >
      <Media mediaKey={mediaKey} open={isOpenMedia} close={closeMedia} />
      <Form form={form} id="create-room" layout="vertical" onFinish={handleSubmit} onFinishFailed={handleWarningMissingFields}>
        <Form.Item name={"id"} hidden>
          <Input />
        </Form.Item>
        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.img !== currentValues.img}>
          {({ getFieldValue }) => {
            return (
              <div className="relative">
                <p className="pb-[8px]">Imagem</p>
                <div
                  className="relative border border-dashed border-gray-300 mb-6 cursor-pointer flex justify-center items-center h-[120px] w-full overflow-hidden"
                  onClick={() => openMedia("img")}
                  style={{
                    backgroundImage: `url(${config.server_ip}media/${getFieldValue("img")})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                >
                  {!getFieldValue("img") ? (
                    <div className="flex justify-center items-center flex-col p-10">
                      <FileImageOutlined className="text-[30px]" /> <p className="text-[11px] text-center mt-2">Selecionar Imagem</p>
                    </div>
                  ) : null}
                </div>

                <Form.Item name={"img"} hidden>
                  <Input />
                </Form.Item>
              </div>
            );
          }}
        </Form.Item>

        <Form.List name={"answers"}>
          {(fieldsAnswer, { add, remove, move }) => (
            <div className="p-6 border border-dashed ">
              {fieldsAnswer.length > 0 && (
                <div className={`grid grid-cols-6 gap-4 mb-4`}>
                  <div className="col-span-5">
                    <p>Respostas</p>
                  </div>
                  <div className="flex items-center">
                    <p>É correta?</p>
                  </div>
                </div>
              )}
              {fieldsAnswer.map((f) => (
                <div className={`grid grid-cols-6 gap-4 mb-4`}>
                  <div className="col-span-5">
                    <Form.Item name={[f.name, "title"]} className="mb-0!">
                      <Input size="large" />
                    </Form.Item>
                  </div>
                  <div className="flex justify-center items-center">
                    <Form.Item name={[f.name, "is_correct"]} className="w-full! mb-0!" valuePropName="checked">
                      <Switch size="large" defaultValue={false} />
                    </Form.Item>
                  </div>
                </div>
              ))}
              <Button onClick={() => add()}>Adicionar resposta</Button>
            </div>
          )}
        </Form.List>
      </Form>
    </Drawer>
  );
}
